import router from "@/router/router";
import {postLog} from "@/js/apihelper";

export const jumphelper = {
    jumpToSelect:()=>{
        router.replace('/select')
        //postLog('页面跳转-主页')
    },
    jumpToDead:()=>{
        router.replace('/dead')
        postLog('页面跳转-墓志铭')
    },
    jumpToMe:()=>{
        router.replace('/me')
        postLog('页面跳转-我')
    },
    jumpToMyBooks:()=>{
        router.replace('/mybooks')
        postLog('页面跳转-我的书架')
    },
    jumpToMyGit:()=>{
        router.replace('/mygit')
        postLog('页面跳转-我的开源')
    },
    jumpToMyMusic:()=>{
        router.replace('/mymusic')
        postLog('页面跳转-音乐')
    },
    jumpToMyPlan:()=>{
        router.replace('/myplan')
        postLog('页面跳转-挑战板')
    },
    jumpToMySpace:()=>{
        router.replace('/myspace')
        postLog('页面跳转-我的空间')
    },
    jumpToMyTravel:()=>{
        router.replace('/mytravel')
        postLog('页面跳转-旅行日志')
    },
    jumpToMyVideos:()=>{
        router.replace('/myvideos')
        postLog('页面跳转-视频-输入密码')
    },
    jumpToMyVideosDeep:()=>{
        router.replace('/phone/myvideos/deep')
    },
    jumpToManagerPassword:()=>{
        router.replace('/phone/managerpassword')
        postLog('页面跳转-管理员密码')
    },
    jumpToManagerSelect:()=>{
        router.replace('/phone/managerselect')
        postLog('页面跳转-管理员选择页面')
    }
}